import React, { lazy } from 'react';
import PrivateRoute from '@/privateRoute';

const Subscription = lazy(() => import('.'));

const routes = [
  {
    path: '/subscription',
    element: (
      <PrivateRoute>
        <Subscription />
      </PrivateRoute>
    ),
    title: 'Subscription',
  }
];

export default routes;
